import useSWR from 'swr';

import { fetchSegment } from 'src/store/api';

function fetcher(segmentIds, options) {
  if (!segmentIds.length) {
    return undefined;
  }
  return Promise.all(segmentIds.map((id) => fetchSegment(id, options)));
}

const defaultConfig = {
  shouldFetch: true,
  revalidateIfStale: false,
  revalidateOnFocus: false,
};

export default function usePxScores({ segmentIds, options = {}, config = {} }) {
  const { shouldFetch, ...swrConfig } = { ...defaultConfig, ...config };

  const base = '/core/v1/segments/:id';
  const urls = [base, ...segmentIds.sort().map((segmentId) => base.replace(':id', segmentId))];

  return useSWR(
    shouldFetch ? { key: urls, segmentIds, options } : null,
    ({ segmentIds: s, options: o }) => fetcher(s, o),
    swrConfig
  );
}
